<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">
                <app-i18n code="home.menu"></app-i18n>
            </el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/location' }">
                <app-i18n code="entities.location.menu"></app-i18n>
            </el-breadcrumb-item>
            <el-breadcrumb-item>
                <app-i18n code="entities.location.view.title"></app-i18n>
            </el-breadcrumb-item>
        </el-breadcrumb>

        <div class="app-content-page">
            <h1 class="app-content-title app-content-title--hidden">
                <app-i18n code="entities.location.view.title"></app-i18n>
            </h1>

            <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

            <app-location-view-toolbar v-if="record"></app-location-view-toolbar>

            <el-form
                :label-position="labelPosition"
                :label-width="labelWidthForm"
                @submit.prevent.native
                class="form"
                v-if="record"
            >
                <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

                <app-view-item-text :label="fields.name.label" :value="presenter(record, 'name')"></app-view-item-text>

                <app-view-item-text
                    :label="fields.information.label"
                    :value="presenter(record, 'information')"
                ></app-view-item-text>

                <app-view-item-text
                    :label="fields.createdAt.label"
                    :value="presenter(record, 'createdAt')"
                ></app-view-item-text>

                <app-view-item-text
                    :label="fields.updatedAt.label"
                    :value="presenter(record, 'updatedAt')"
                ></app-view-item-text>

                <!-- Search google maps -->
                <el-form-item
                    :label="fields.latitude.label"
                    :prop="fields.latitude.name"
                    :required="fields.latitude.required && fields.longitude.required"
                >
                    <el-col :lg="11" :md="16" :sm="24">
                        <gmap-map
                            :center="center"
                            :zoom="12"
                            style="width:100%;  height: 400px;"
                        >
                            <gmap-marker
                                :key="index"
                                :position="m.position"
                                @click="center=m.position"
                                v-for="(m, index) in markers"
                            ></gmap-marker>
                        </gmap-map>
                    </el-col>
                </el-form-item>
                <!-- END Search google maps -->
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LocationViewToolbar from '@modules/location/components/location-view-toolbar.vue';
import { LocationModel } from '@modules/location/location-model';

const { fields } = LocationModel;

export default {
    name: 'app-location-view-page',

    props: ['id'],

    data() {
        return {
            show: false, // maps
            center: { lat: 45.508, lng: -73.587 },
            markers: [],
            places: [],
            currentPlace: null,
        };
    },

    components: {
        [LocationViewToolbar.name]: LocationViewToolbar,
    },

    mounted() {
        // this.geolocate();
    },

    computed: {
        ...mapGetters({
            labelPosition: 'layout/labelPosition',
            labelWidthForm: 'layout/labelWidthForm',
            record: 'location/view/record',
            loading: 'location/view/loading',
        }),

        fields() {
            return fields;
        },
    },

    async created() {
        await this.doFind(this.id);
        this.addMarker()
    },

    methods: {
        ...mapActions({
            doFind: 'location/view/doFind',
        }),

        presenter(record, fieldName) {
            return LocationModel.presenter(
                record,
                fieldName,
            );
        },
        addMarker() {
            this.show = true;
            if (this.markers.lenght > 0) {
                this.markers = [];
            }

            const marker = {
                    lat: Number(this.record.latitude),
                    lng: Number(this.record.longitude),
                };
            this.markers.push({ position: marker });
            this.places.push(this.currentPlace);
            this.center = marker;
        },
    },
};
</script>
